module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    attrs: {
      "id": "logged-details"
    }
  }, [(!_vm.settingsMode) ? _c('h1', [_vm._v(_vm._s(_vm.loggedUser.alias))]) : _vm._e(), _vm._v(" "), (!_vm.settingsMode) ? _c('div', {
    staticClass: "primary-details"
  }, [_c('input', {
    staticClass: "input-file",
    attrs: {
      "type": "file",
      "name": "new-avatar",
      "id": "new-avatar"
    },
    on: {
      "change": _vm.uploadNewAvatar
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "avatar",
    attrs: {
      "for": "new-avatar"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.avatarImage
    }
  }), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "details"
  }, [_c('a', {
    attrs: {
      "href": ("/Profile/" + (_vm.loggedUser.stringUrl)),
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-user"
  }), _vm._v(" My Profile")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.settingsMode = true
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-cog"
  }), _vm._v(" Settings")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.logout($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-sign-out"
  }), _vm._v(" Logout")])])]) : _vm._e(), _vm._v(" "), (_vm.settingsMode) ? _c('div', {
    staticClass: "settings"
  }, [_c('h1', [_vm._v("Settings")]), _vm._v(" "), _c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.useMetric),
      expression: "useMetric"
    }],
    attrs: {
      "type": "checkbox",
      "disabled": _vm.savingSettings
    },
    domProps: {
      "checked": Array.isArray(_vm.useMetric) ? _vm._i(_vm.useMetric, null) > -1 : (_vm.useMetric)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.useMetric,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.useMetric = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.useMetric = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.useMetric = $$c
        }
      }
    }
  }), _vm._v(" Use Metric")]), _vm._v(" "), _c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.useSwearFilter),
      expression: "useSwearFilter"
    }],
    attrs: {
      "type": "checkbox",
      "disabled": _vm.savingSettings
    },
    domProps: {
      "checked": Array.isArray(_vm.useSwearFilter) ? _vm._i(_vm.useSwearFilter, null) > -1 : (_vm.useSwearFilter)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.useSwearFilter,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.useSwearFilter = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.useSwearFilter = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.useSwearFilter = $$c
        }
      }
    }
  }), _vm._v(" Filter Swear Words")]), _vm._v(" "), _c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ignoreThreshold),
      expression: "ignoreThreshold"
    }],
    attrs: {
      "type": "number",
      "disabled": _vm.savingSettings
    },
    domProps: {
      "value": (_vm.ignoreThreshold)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.ignoreThreshold = $event.target.value
      }
    }
  }), _vm._v(" Auto-ignore Threshold")]), _vm._v(" "), _c('button', {
    attrs: {
      "disabled": _vm.savingSettings
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.saveSettings($event)
      }
    }
  }, [_vm._v("Save Settings")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "friend-requests"
  }, [(!_vm.showFriendRequests) ? [_c('a', {
    staticClass: "request-link",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.showFriendRequests = true
      }
    }
  }, [(!_vm.retrievedPendingFriendRequests) ? _c('i', {
    staticClass: "fa fa-spin fa-circle-o-notch"
  }) : _vm._e(), _vm._v(" "), (_vm.retrievedPendingFriendRequests) ? _c('span', [_vm._v(_vm._s(_vm.pendingFriendRequests.length))]) : _vm._e(), _vm._v(" "), _c('span', [_vm._v("Friend Request")]), (_vm.pendingFriendRequests.length !== 1) ? _c('span', [_vm._v("s")]) : _vm._e()])] : _vm._e(), _vm._v(" "), (_vm.showFriendRequests) ? [_c('a', {
    staticClass: "return-from-friend-requests",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.showFriendRequests = false
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-circle-left"
  }), _vm._v(" Return")]), _vm._v(" "), (!_vm.retrievedPendingFriendRequests) ? _c('loader-large') : _vm._e(), _vm._v(" "), (_vm.retrievedPendingFriendRequests) ? [(_vm.pendingFriendRequests.length === 0) ? _c('div', {
    staticClass: "no-pending-requests"
  }, [_vm._v("You have no pending friend requests")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.pendingFriendRequests), function(pendingFriendRequest) {
    return _c('div', {
      staticClass: "pending-friend-request"
    }, [_c('a', {
      attrs: {
        "href": ("/Profile/" + (pendingFriendRequest.senderStringUrl)),
        "target": "_blank"
      }
    }, [_c('img', {
      attrs: {
        "src": _vm.generateFriendRequestAvatar(pendingFriendRequest)
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "friend-request-details"
    }, [_c('a', {
      attrs: {
        "href": ("/Profile/" + (pendingFriendRequest.senderStringUrl)),
        "target": "_blank"
      }
    }, [_vm._v("\n                            " + _vm._s(pendingFriendRequest.senderAlias) + "\n                        ")]), _vm._v(" "), _c('div', {
      staticClass: "button-container"
    }, [_c('button', {
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.acceptFriendRequest(pendingFriendRequest)
        }
      }
    }, [_vm._v("Accept")]), _vm._v(" "), _c('button', {
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.declineFriendRequest(pendingFriendRequest)
        }
      }
    }, [_vm._v("Decline")])])])])
  })] : _vm._e()] : _vm._e()], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "upload-overlay"
  }, [_c('i', {
    staticClass: "fa fa-upload"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7cce7f32"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Chatroom/ChatSidePanelWidgets/LoggedDetails.vue
// module id = 406
// module chunks = 1